import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getMonthTargetCounter, addMonthTargetCounter, deleteMonthTargetCounter, getTotalCounter } from '@/api/bairun/financialCenter';
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name: 'StationMonthTarget',
  data: function data() {
    return {
      datePickerValue: new Date(),
      groupData: [],
      lastApps: [],
      apps: [],
      totalId: 0,
      dialogFormVisible: false,
      rules: {
        stationId: [{
          required: true,
          message: '必选',
          trigger: 'change'
        }],
        target: [{
          required: true,
          min: 0.01,
          type: 'number',
          message: '目标值需大于0',
          trigger: 'change'
        }]
      },
      temp: {
        stationId: 0,
        target: 0,
        month: moment.unix(new Date() / 1000).format('YYYYMM'),
        lastMonthPetrolAvg: 0,
        lastMonthDieselAvg: 0,
        lastYearPetrolAvg: 0,
        lastYearDieselAvg: 0
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('stations', ['asyncStations'])), mapGetters('user', ['userInfo'])),
  watch: {
    datePickerValue: function datePickerValue() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['targetTable'].doLayout();
      });
      this.loadData();
    }
  },
  created: function created() {
    // console.log(this.roles)
    this.loadData();
  },
  methods: {
    showStationName: function showStationName(stationId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === stationId) {
          return this.asyncStations[i]['statAbbr'];
        }
      }

      return '';
    },
    stationIdChanged: function stationIdChanged(stationId) {
      if (this.groupData[stationId]) {
        this.temp.lastMonthPetrolAvg = this.groupData[stationId]['dailyPerPetrolNums'];
        this.temp.lastMonthDieselAvg = this.groupData[stationId]['dailyPerDieselNums'];
      } else {
        this.temp.lastMonthPetrolAvg = 0;
        this.temp.lastMonthDieselAvg = 0;
      }

      this.temp.lastYearPetrolAvg = 0;
      this.temp.lastYearDieselAvg = 0;

      var _that = this;

      if (this.lastApps.length > 0) {
        this.lastApps.forEach(function (value) {
          if (stationId === value.stationId) {
            _that.temp.lastYearPetrolAvg = value.lastYearPetrolAvg;
            _that.temp.lastYearDieselAvg = value.lastYearDieselAvg;
          }
        });
      }

      this.temp.stationId = stationId;
    },
    loadData: function loadData() {
      var _this2 = this;

      getMonthTargetCounter({
        month: moment.unix(this.datePickerValue / 1000).format('YYYYMM')
      }).then(function (response) {
        _this2.apps = response.data; // todo 前端处理隐藏  后面后端下发数据限制

        _this2.totalId = parseInt(_this2.userInfo.authorityId) < 30003 ? 999 : _this2.userInfo.sellerId;

        if (_this2.totalId > 999) {
          _this2.apps.forEach(function (item, i) {
            if (_this2.totalId !== item.stationId) {
              delete _this2.apps[i];
            }
          });
        }
      });
    },
    showCreateDialog: function showCreateDialog() {
      var _this3 = this;

      this.temp.stationId = 0;
      this.temp.target = 0;
      this.temp.lastMonthPetrolAvg = 0;
      this.temp.lastMonthDieselAvg = 0;
      this.temp.lastYearPetrolAvg = 0;
      this.temp.lastYearDieselAvg = 0;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          name: 'StationOilSoldOCOSOTPCCounter',
          start: moment(new Date(this.datePickerValue)).startOf('month').unix() - 3600 * 48,
          end: moment(new Date(this.datePickerValue)).startOf('month').unix() - 3600 * 24
        }]
      };
      getTotalCounter(descriptorData).then(function (response) {
        _this3.groupData = response.data;
      }).catch(function () {
        _Message({
          message: '获取上月销量数据异常，请手动输入',
          type: 'warning',
          duration: 2 * 1000
        });

        _this3.dialogFormVisible = false;
      });
      getMonthTargetCounter({
        month: moment.unix(descriptorData.descriptors[0]['end']).format('YYYYMM')
      }).then(function (response) {
        _this3.lastApps = response.data;
      });
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });
    },
    doCreateHandle: function doCreateHandle() {
      var _this4 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this4.temp.stationId === 0) {
            _Message({
              message: '请选择有效站点进行设置',
              type: 'warning',
              duration: 2 * 1000
            });

            return;
          }

          _this4.temp.month = parseInt(moment.unix(_this4.datePickerValue / 1000).format('YYYYMM'));
          addMonthTargetCounter(_this4.temp).then(function (response) {
            if (response.code > 0) {
              _Message({
                message: response.msg,
                type: 'error',
                duration: 2 * 1000
              });

              return;
            }

            _this4.dialogFormVisible = false; // console.log(response)

            _this4.loadData();

            _Message({
              message: '创建成功',
              type: 'success',
              duration: 2 * 1000
            });
          });
        }
      });
    },
    doDeleteApp: function doDeleteApp(id, month) {
      var _this5 = this;

      this.$confirm('确认删除此数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteMonthTargetCounter({
          id: id,
          month: month
        }).then(function (res) {
          if (res.code > 0) {
            _Message({
              message: res.msg,
              type: 'error',
              duration: 2 * 1000
            });

            return;
          }

          _this5.loadData();

          _Message({
            message: '删除成功',
            type: 'success',
            duration: 2 * 1000
          });
        });
      });
    }
  }
};